import { render, staticRenderFns } from "./CardInfoV0.vue?vue&type=template&id=4a7ff142&scoped=true&"
import script from "./CardInfoV0.vue?vue&type=script&lang=js&"
export * from "./CardInfoV0.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoV0.vue?vue&type=style&index=0&id=4a7ff142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7ff142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7ff142')) {
      api.createRecord('4a7ff142', component.options)
    } else {
      api.reload('4a7ff142', component.options)
    }
    module.hot.accept("./CardInfoV0.vue?vue&type=template&id=4a7ff142&scoped=true&", function () {
      api.rerender('4a7ff142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/CardInfo/Merchant/CardInfoV0.vue"
export default component.exports